import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FinancialDetailsPage.css';

function FinancialDetailsPage({ data, updateData }) {
  const [formData, setFormData] = useState(data.financialDetails || {
    monthlyIncome: '',
    incomeSource: '',
    hasOtherIncome: ''
  });
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleContinue = () => {
    if (!formData.monthlyIncome || !formData.incomeSource || !formData.hasOtherIncome) {
      alert('Please fill in all financial details');
      return;
    }
    
    updateData('financialDetails', formData);
    navigate('/device-details');
  };

  return (
    <div className="financial-details-page">
      <div className="container">
        <div className="page-header">
          <h2>Financial Details</h2>
          <p>Provide your financial information</p>
        </div>

        <form className="financial-form">
          <div className="form-group">
            <label>Average Monthly Income (Ksh) *</label>
            <input
              type="number"
              name="monthlyIncome"
              value={formData.monthlyIncome}
              onChange={handleChange}
              placeholder="Enter amount"
              min="0"
              required
            />
          </div>

          <div className="form-group">
            <label>Briefly describe your source of income *</label>
            <textarea
              name="incomeSource"
              value={formData.incomeSource}
              onChange={handleChange}
              placeholder="Describe your income source..."
              rows="3"
              required
            />
          </div>

          <div className="form-group">
            <label>Do you have any other source of income? *</label>
            <div className="radio-group">
              {['Yes', 'No'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="hasOtherIncome"
                    value={option.toLowerCase()}
                    checked={formData.hasOtherIncome === option.toLowerCase()}
                    onChange={handleChange}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>

          <button 
            type="button"
            className="continue-btn"
            onClick={handleContinue}
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}

export default FinancialDetailsPage;